import { useState } from 'react';
import { sendApiRequest } from '../../api/request';
import EditingPanel from './EditingPanel';

export default function PhoneNumbers() {
  const [action, setAction] = useState('create'); // 'create' | 'delete'
  const [id, setId] = useState('');
  const [language, setLanguage] = useState('');
  const [name, setName] = useState('');
  const [number, setNumber] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    setMessage('');
    if (!id || !language) {
      setMessage('Please provide both ID and language.');
      return;
    }

    try {
      if (action === 'create') {
        if (!name || !number) {
          setMessage('Please provide name and phone number.');
          return;
        }

        const phoneData = {
          phoneNumberId: { id: Number(id), language },
          name,
          number,
        };

        const savedPhone = await sendApiRequest('POST', '/admin/phonenumbers', phoneData);
        setMessage(`Phone number saved: ${savedPhone?.name ?? name} (${savedPhone?.phoneNumberId?.language ?? language})`);
      } else {
        await sendApiRequest('DELETE', `/admin/phonenumbers/number?id=${id}&language=${language}`);
        setMessage(`Phone number with ID ${id} (${language}) deleted.`);
      }

      // reset fields
      setId('');
      setLanguage('');
      setName('');
      setNumber('');
    } catch (error) {
      setMessage(`${error?.message ?? 'Request failed'}`);
    }
  };

  return (
    <EditingPanel
      title={action === 'create' ? 'Create / Update Phone Number' : 'Delete Phone Number'}
      action={action}
      onActionChange={setAction}
      actions={[
        { value: 'create', label: 'Create / Update' },
        { value: 'delete', label: 'Delete' },
      ]}
      topRow={
        <>
          <div className="editing-panel__field">
            <label>Phone ID</label>
            <input
              type="number"
              value={id}
              onChange={(e) => setId(e.target.value)}
              placeholder="Enter phone ID"
            />
          </div>

          <div className="editing-panel__field">
            <label>Language</label>
            <input
              type="text"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              placeholder="e.g. en or no"
            />
          </div>
        </>
      }
      grid={
        action === 'create' && (
          <>
            <div className="editing-panel__field">
              <label>Name / Label</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g. Taxi, Support, Emergency"
              />
            </div>

            <div className="editing-panel__field">
              <label>Phone Number</label>
              <input
                type="text"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                placeholder="e.g. +47 123 45 678"
              />
            </div>
          </>
        )
      }
      onSubmit={handleSubmit}
      isDanger={action === 'delete'}
      submitLabel={action === 'delete' ? 'Delete Phone Number' : 'Save Phone Number'}
      message={message}
    />
  );
}
